module.exports = __webpack_public_path__ + "img/sleeve_ruffle_width.71055ad0.png";